export const routes = {
    login: '/login',
    registration: '/registration',
    forgotPassword: '/forgot-password',
    home: '/home',
    folder: '/folder/:folderID',
}
